import { AstNodeCategory, AstNodeType } from './node';
export class PrefixExpression {
    constructor(token, operator, right) {
        this.token = token;
        this.operator = operator;
        this.right = right;
        this.nodeType = AstNodeType.PrefixExpression;
        this.nodeCategory = AstNodeCategory.Expression;
    }
    get Operator() {
        return this.operator;
    }
    set Operator(val) {
        this.operator = val;
    }
    get Right() {
        return this.right;
    }
    set Right(val) {
        this.right = val;
    }
    tokenLiteral() {
        return this.token.literal;
    }
    toString() {
        return `(${this.operator}${this.right.toString()})`;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJlZml4RXhwcmVzc2lvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvYXN0L1ByZWZpeEV4cHJlc3Npb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUFFLGVBQWUsRUFBRSxXQUFXLEVBQWMsTUFBTSxRQUFRLENBQUM7QUFFbEUsTUFBTSxPQUFPLGdCQUFnQjtJQUN6QixZQUNZLEtBQVksRUFDWixRQUFpQixFQUNqQixLQUFrQjtRQUZsQixVQUFLLEdBQUwsS0FBSyxDQUFPO1FBQ1osYUFBUSxHQUFSLFFBQVEsQ0FBUztRQUNqQixVQUFLLEdBQUwsS0FBSyxDQUFhO1FBRzlCLGFBQVEsR0FBZ0IsV0FBVyxDQUFDLGdCQUFnQixDQUFDO1FBQ3JELGlCQUFZLEdBQW9CLGVBQWUsQ0FBQyxVQUFVLENBQUM7SUFIeEQsQ0FBQztJQUtKLElBQUksUUFBUTtRQUNSLE9BQU8sSUFBSSxDQUFDLFFBQVEsQ0FBQztJQUN6QixDQUFDO0lBRUQsSUFBSSxRQUFRLENBQUMsR0FBRztRQUNaLElBQUksQ0FBQyxRQUFRLEdBQUcsR0FBRyxDQUFDO0lBQ3hCLENBQUM7SUFFRCxJQUFJLEtBQUs7UUFDTCxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUM7SUFDdEIsQ0FBQztJQUVELElBQUksS0FBSyxDQUFDLEdBQUc7UUFDVCxJQUFJLENBQUMsS0FBSyxHQUFHLEdBQUcsQ0FBQztJQUNyQixDQUFDO0lBRUQsWUFBWTtRQUNSLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUM7SUFDOUIsQ0FBQztJQUVELFFBQVE7UUFDSixPQUFPLElBQUksSUFBSSxDQUFDLFFBQVEsR0FBSSxJQUFJLENBQUMsS0FBb0IsQ0FBQyxRQUFRLEVBQUUsR0FBRyxDQUFDO0lBQ3hFLENBQUM7Q0FDSiJ9